<template>
  <div>
    <profile-basic-data-card
      @update-email="emailUpdated"
      :readonly="readonly"
    />

    <profile-attributes-list
      @attribute-updated="attributeUpdated"
      :readonly="readonly"
    />

    <profile-aggregates-list v-if="aggregatesEnabled" :readonly="readonly" />
  </div>
</template>

<script>
import ProfileBasicDataCard from '@/modules/profiles/components/ProfileBasicDataCard'
import ProfileAttributesList from '@/modules/profiles/components/ProfileAttributesList'
import ProfileAggregatesList from '../components/ProfileAggregatesList'
import { $hasFeature } from '../../../core/utils/VueAcl'

export default {
  name: 'ProfileDataPage',

  components: {
    ProfileAggregatesList,
    ProfileBasicDataCard,
    ProfileAttributesList
  },

  props: {
    readonly: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    emailUpdated(newEmail) {
      this.$emit('email-updated', newEmail)
    },

    attributeUpdated(attributeModel) {
      this.$emit('attribute-updated', attributeModel)
    }
  },

  computed: {
    aggregatesEnabled() {
      return $hasFeature('aggregatesEnabled')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileDataPage.vue